<template>
    <div class="article privacy" v-if="$root.dataReady">
        <header class="heading">
            <div class="container">
              <div class="text">
                <h2>{{page.title.rendered}}</h2>
              </div>
            </div>
        </header>
        <div class="container">
            <div class="post-content" v-html="page.content.rendered"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "privacy-page",
    data() {
        return {
            page: null
        };
    },
    created: function() {
        this.$root.headeriswhite = false;
        this.$root.dataReady = false;
    },
    mounted: function() {
        this.fetchData();
    },
    props: ["slug"],
    methods: {
        fetchData: function() {
            var self = this;
            $.get(
                self.$root.apiUrl +
                    "wp-json/wp/v2/pages?slug=" + self.slug,
                function(response) {
                    self.page = response[0];
                    self.setTitle(response[0].title.rendered);
                    self.$root.dataReady = true;
                }
            )
                .done(function() {})
                .fail(function() {});
        },
        setTitle: function(title) {
            title = title.normalize('NFD').replace("&#038;", "&");
            document.title = title + " - Weber Shandwick";
        }
    }
};
</script>



// WEBPACK FOOTER //
// TermsAndConditions.vue?a442f28c